import { apiClient } from "lib/apiClient";

export const analyzeMarketArea = async (id: string): Promise<void> => {
  await apiClient.post(`/market-areas/${id}/analyze`);
};
